import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import moment from "moment";

export default class Messages extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    modifyMessage: PropTypes.func
  };

  static defaultProps = {
    data: []
  };

  constructor(props) {
    super(props);
    this.markAsRead = this.markAsRead.bind(this);
  }

  markAsRead(data) {
    if (!data.read) {
      setTimeout(() => {
        this.props.modifyMessage(data.id, false, true);
      }, 1000);
    }
  }

  render() {
    return (
      <span>
        {this.props.data.length !== 0 ? (
          <div className="menu-scroll" style={styles.wrapper}>
            <ul style={styles.messages} className="messages-list">
              {this.props.data
                .slice(0)
                .reverse()
                .map((data, index) => {
                  return (
                    <li key={index} style={styles.list} className={data.read ? "read" : "unread"} onMouseEnter={() => this.markAsRead(data)}>
                      {data.content === "You have intros expiring soon." ? (
                        <div>
                          You have intros expiring soon.
                          <a className="see-list" style={styles.list.see} href={data.desktopLinkURL} target="_raw_data_tab">
                            View List
                          </a>
                        </div>
                      ) : (
                        data.content
                      )}
                      <p style={styles.list.createdBy}>
                        Created by {data.createdBy} on {moment(data.createdAt).format("LLL")}
                      </p>
                      <a style={styles.list.mark} onClick={() => this.props.modifyMessage(data.id, false, false)}>
                        <span className="mark-as-unread">
                          <FontAwesomeIcon icon={faEnvelope} style={{ color: "rgb(111, 164, 253)" }} />
                          <span style={styles.unread}>Mark As Unread</span>
                        </span>
                      </a>
                      <a style={styles.list.delete} onClick={() => this.props.modifyMessage(data.id, true, true)}>
                        <span className="delete">
                          <FontAwesomeIcon icon={faTrashAlt} style={{ color: "red" }} />
                          <span style={styles.delete}>Delete</span>
                        </span>
                      </a>
                    </li>
                  );
                })}
            </ul>
          </div>
        ) : (
          <p style={styles.noMessages}>No messages found.</p>
        )}
      </span>
    );
  }
}

let styles = {
  wrapper: {
    maxHeight: "540px",
    overflowY: "scroll",
    padding: "0px 8px 0 12px",
    minHeight: "540px"
  },
  messages: {
    WebkitPaddingStart: "0px"
  },
  noMessages: {
    height: "350px",
    textAlign: "center",
    paddingTop: "140px"
  },
  unread: {
    paddingLeft: "3px",
    color: "rgb(111, 164, 253)"
  },
  delete: {
    paddingLeft: "3px",
    color: "red"
  },
  list: {
    color: "white",
    listStyleType: "none",
    paddingTop: "12px",
    paddingBottom: "12px",
    borderBottom: "dashed 1px rgba(91, 96, 106, 0.28)",
    textAlign: "left",
    lineHeight: "18px",
    paddingLeft: "10px",
    see: {
      color: "rgb(111, 164, 253)",
      fontWeight: 600
    },
    createdBy: {
      fontSize: "11px",
      color: "#cccccc",
      margin: 0,
      paddingBottom: "10px"
    },
    mark: {
      fontSize: "11px",
      color: "#cccccc",
      cursor: "pointer"
    },
    delete: {
      fontSize: "11px",
      color: "#cccccc",
      cursor: "pointer",
      paddingLeft: "10px"
    }
  }
};
